import { render, staticRenderFns } from "./pointsMall.vue?vue&type=template&id=611d10db&scoped=true&"
import script from "./pointsMall.vue?vue&type=script&lang=js&"
export * from "./pointsMall.vue?vue&type=script&lang=js&"
import style0 from "./pointsMall.vue?vue&type=style&index=0&id=611d10db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611d10db",
  null
  
)

export default component.exports